import { MoCommand } from './command';
import { playSkillSounds } from '../../helpers/soundmanager';
import { playSkillCastEffect } from '../../effects/effectmanager';

export class SkillToSelfCmd extends MoCommand {
  pawn: any;
  skillData: any;

  constructor(object: any, skillData: any) {
    super(object);
    this.pawn = this.object.pawn;
    this.skillData = skillData;
  }

  enter() {
    playSkillSounds(this.skillData, SKILL.CASTING_SOUND1);
    playSkillCastEffect(this.pawn, this.skillData);
    let motionIdx = this.skillData[SKILL.CASTING_MOTION];
    let timeScale = this.skillData[SKILL.CASTING_SPEED] / 100;
    this.pawn.playMotion(motionIdx, timeScale, 1, function(anim) {
      anim.once('finish', this._skillCastDone.bind(this));
    }.bind(this));
  }

  _skillCastDone() {
    playSkillSounds(this.skillData, SKILL.REPEAT_SOUND1);
    let motionIdx = this.skillData[SKILL.REPEAT_MOTION];
    let timeScale = this.skillData[SKILL.CASTING_SPEED] / 100;
    let repeatCount = this.skillData[SKILL.REPEAT_COUNT];
    if (repeatCount < 1) {
      repeatCount = 1;
    }
    this.pawn.playMotion(motionIdx, timeScale, repeatCount, function(anim) {
      anim.once('finish', this._skillRepeatDone.bind(this));
    }.bind(this));
  }

  _skillRepeatDone() {
    playSkillSounds(
      this.skillData,
      SKILL.ACTION_SOUND1,
      SKILL.ACTION_SOUND2,
      SKILL.SHOT_SOUND,
      SKILL.HIT_SOUND,
      SKILL.HIT_SOUND2,
      SKILL.HIT_SOUND3,
      SKILL.AREA_SOUND,
    );
    const motionIdx = this.skillData[SKILL.MOTION];
    const timeScale = this.skillData[SKILL.SPEED] / 100;
    this.pawn.playMotion(motionIdx, timeScale, 1, function(anim) {
      anim.once('finish', this._skillDone.bind(this));
    }.bind(this));
  }

  _skillDone() {
    this.isComplete = true;
    this.emit('finish');
  }

  leave() {
  }

  update(delta: number) {
    return 0;
  }
}
